import { KVRepository, Repository } from './type';

export class JsonRepository<T> implements Repository<T> {
  load(value: string) {
    return JSON.parse(value);
  }

  dump(value: T | undefined) {
    return JSON.stringify(value);
  }
}

export class StorageRepository<T> extends JsonRepository<T> implements KVRepository<T> {
  private storage: Storage;

  constructor(storate: Storage) {
    super();
    this.storage = storate;
  }

  keys() {
    const keys: string[] = [];

    for (let i = 0, len = this.storage.length; i < len; ++i) {
      const key = this.storage.key(i) as string;
      keys.push(key);
    }

    return keys;
  }

  get(key: string, fallback?: T): T | undefined {
    const value = this.storage.getItem(key);

    if (value) {
      return this.load(value);
    }

    return fallback;
  }

  set(key: string, value: T | undefined) {
    this.storage.setItem(key, this.dump(value));
  }

  unset(key: string) {
    this.storage.removeItem(key);
  }

  has(key: string) {
    return this.keys().includes(key);
  }
}
